import { adminApiClient } from './client'
import { UploadSession } from '../types/image'

export const uploadApi = {
  init: async (params: {
    filename: string
    contentType: string
    fileSize: number
  }): Promise<UploadSession> => {
    const response = await adminApiClient.post('/upload/init', params)
    return response.data.data
  },

  complete: async (uploadId: string, metadata: {
    albumId: string
    tags?: string[]
    dateCaptured?: string
  }): Promise<{ imageId: string; message: string }> => {
    const response = await adminApiClient.post('/upload/complete', {
      uploadId,
      metadata,
    })
    return response.data.data
  },

  uploadToS3: async (presignedUrl: string, file: File, onProgress?: (progress: number) => void): Promise<void> => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable && onProgress) {
          const progress = Math.round((event.loaded / event.total) * 100)
          onProgress(progress)
        }
      })

      xhr.addEventListener('load', () => {
        if (xhr.status === 200) {
          resolve()
        } else {
          reject(new Error(`Upload failed: ${xhr.statusText}`))
        }
      })

      xhr.addEventListener('error', () => {
        reject(new Error('Upload failed'))
      })

      xhr.open('PUT', presignedUrl, true)
      xhr.setRequestHeader('Content-Type', file.type)
      xhr.send(file)
    })
  },
}
